import queryString from 'querystring';

export function decodeAuthToken(authToken) {
    let localAuthToken = '';
    try {
        localAuthToken = decodeURIComponent(authToken);
    } catch(e) {
        console.error(e);
    }
    return localAuthToken;
}

export const getValueFromQueryString = (key) => {
  const queryParams = window.location.search;
  const query = queryParams.replace('?', '');
  const params = queryString.parse(query);
  return params[key];
};

const knownLocales = {
  'en-au': 'en-AU',
  'en-us': 'en-US',
  'es-es': 'es-ES',
  'es-la': 'es-LA',
  'es-mx': 'es-ES'
};

export const formatLocale = (locale) => { 
  return knownLocales[locale.toLowerCase()] || 'en-AU'; 
};
